import { Pipe, PipeTransform } from '@angular/core';
import { CallQueueUser } from 'src/generated/graphql';

@Pipe({name: 'skillRatingFilter', pure:false})
export class SkillRatingFilterPipe implements PipeTransform {

  transform(value: CallQueueUser[], skillRating: number| null): CallQueueUser[] {
    return value.filter(u=> u.skillRating == skillRating);
  }
}